import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-lineup',
  templateUrl: './product-lineup.component.html',
  styleUrls: ['./product-lineup.component.css']
})
export class ProductLineupComponent implements OnInit {

  constructor() { }
  mobile: boolean = false;
  ngOnInit(): void {
    if (window.screen.width < 640) { // 768px portrait
      this.mobile = true;

    }
    else {
      this.mobile = false;
    }

  }
  goToLink(url: string){
    window.open(url, "_blank");
}

}
